import React from "react";
import { TFrontMainColours } from "../../../../models/TFrontMainColours";
import * as TCurrency from "../../../../../../domain/models/TCurrency";
import { requireExhaustive } from "../../../../../../shared/src/util";
import FrontButtonMicro from "./../../Simple/FrontButtonMicro/FrontButtonMicro";
import FrontButtonPrimary from "./../../Simple/FrontButtonPrimary/FrontButtonPrimary";
import { FrontRow } from "../../../FrontRow/FrontRow";
import { FrontIcon } from "../../Simple/FrontIcon/FrontIcon";
import { FrontInputCurrencyHuge } from "../../Simple/FrontInputHuge/FrontInputCurrencyHuge";
import { FrontOfferSummaryGauge } from "../FrontOfferSummaryGauge/FrontOfferSummaryGauge";
import { FrontOfferSummaryStatusIcon } from "../../Simple/FrontOfferSummaryStatusIcon/FrontOfferSummaryStatusIcon";
import { FrontTitlePageSection } from "../../../Front/Simple/FrontPageSectionTitle/FrontTitlePageSection";
import FrontParagraphSmall from "../../../Front/Simple/FrontParagraphSmall/FrontParagraphSmall";
import FrontParagraphTiny from "../../../Front/Simple/FrontParagraphTiny/FrontParagraphTiny";
import { FrontSpacer } from "../../../FrontSpacer/FrontSpacer";
import { FrontTextColour } from "../../../FrontTextColour/FrontTextColour";
import FrontTitleMinor from "../../Simple/FrontTitleMinor/FrontTitleMinor";
import { Underline } from "../../../Underline/Underline";
import { WeightBold } from "../../../WeightBold/WeightBold";
import { WeightMedium } from "../../../WeightMedium/WeightMedium";
import { FrontCompletionTimeModal } from "../FrontCompletionTimeModal/FrontCompletionTimeModal";
import { FrontFallThroughRiskModal } from "../FrontFallThroughRiskModal/FrontFallThroughRiskModal";
import { TOffer1NewDefault } from "../../../../../../domain/codecs/Offer";
import { TBuyerSubmitsNewOfferFormEditableNewDefault } from "../../../../../../domain/codecs/formEditable/BuyerSubmitsNewOfferFormEditable";
import { TBuyerUpdatesConveyancerDetailsFormEditableNewDefault } from "../../../../../../domain/codecs/formEditable/BuyerUpdatesConveyancerDetailsFormEditable";
import { TBuyerUpdatesMortgageBrokerDetailsFormEditableNewDefault } from "../../../../../../domain/codecs/formEditable/BuyerUpdatesMortgageBrokerDetailsFormEditable";
import { TBuyerUpdatesProofOfFundsFormEditableNewDefault } from "../../../../../../domain/codecs/formEditable/BuyerUpdatesProofOfFundsFormEditable";
import { TBuyerUpdatesClientDetailsFormEditableNewDefault } from "../../../../../../domain/codecs/formEditable/BuyerUpdatesClientDetailsFormEditable";
import { TEstimatedTimeToCompletion1 } from "../../../../../../domain/codecs/EstimatedTimeToCompletion";
import { TRiskOfFallThrough1NewDfault } from "../../../../../../domain/codecs/RiskOfFallThrough";
import { FrontInputGeneralComponent } from "../../Simple/FrontInputGeneralComponent/FrontInputGeneralComponent";
import { FrontInputLabelAndErrorWrapComponent } from "../../Simple/FrontInputLabelAndErrorWrapComponent/FrontInputLabelAndErrorWrapComponent";
import { FrontInputTextareaComponent } from "../../Simple/FrontInputTextareaComponent/FrontInputTextareaComponent";
import { TProofOfFundsDocument2 } from "../../../../../../domain/codecs/ProofOfFundsDocument";
import { ProofOfFundsDocumentFileIO, TProofOfFundsDocumentFileIO } from "../../../../../../domain/codecs/fileIO/ProofOfFundsDocumentFileIO";
import { DeleteProofOfFundsDocumentFormIO } from "../../../../../../domain/codecs/formIO/DeleteProofOfFundsDocumentFormIO";
import { TDeleteProofOfFundsDocumentFormIO } from "../../../../../../domain/codecs/formIO/DeleteProofOfFundsDocumentFormIO";
import { v4 as uuidv4 } from "uuid";
import { pipe } from "fp-ts/lib/function";
import { array, option } from "fp-ts/lib";
import { FrontFormSecondaryButton } from "../../Simple/FrontFormSecondaryButton/FrontFormSecondaryButton";

type TFrontYourOfferSummary = {
    thierLatestOffer: TOffer1NewDefault;
    newOfferForm: TBuyerSubmitsNewOfferFormEditableNewDefault;
    onChangeNewOfferForm: (form: TBuyerSubmitsNewOfferFormEditableNewDefault) => void;
    onSubmitNewOfferForm: (form: TBuyerSubmitsNewOfferFormEditableNewDefault) => void;
    conveyancerForm: TBuyerUpdatesConveyancerDetailsFormEditableNewDefault;
    onChangeConveyancerForm: (form: TBuyerUpdatesConveyancerDetailsFormEditableNewDefault) => void;
    onSubmitConveyancerForm: (form: TBuyerUpdatesConveyancerDetailsFormEditableNewDefault) => void;
    mortgageBrokerForm: TBuyerUpdatesMortgageBrokerDetailsFormEditableNewDefault;
    onChangeMortgageBrokerForm: (form: TBuyerUpdatesMortgageBrokerDetailsFormEditableNewDefault) => void;
    onSubmitMortgageBrokerForm: (form: TBuyerUpdatesMortgageBrokerDetailsFormEditableNewDefault) => void;
    proofOfFundsForm: TBuyerUpdatesProofOfFundsFormEditableNewDefault;
    onChangeProofOfFundsForm: (form: TBuyerUpdatesProofOfFundsFormEditableNewDefault) => void;
    onSubmitProofOfFundsForm: (form: TBuyerUpdatesProofOfFundsFormEditableNewDefault) => void;
    clientDetailsForm: TBuyerUpdatesClientDetailsFormEditableNewDefault;
    onChangeClientDetailsForm: (form: TBuyerUpdatesClientDetailsFormEditableNewDefault) => void;
    onSubmitClientDetailsForm: (form: TBuyerUpdatesClientDetailsFormEditableNewDefault) => void;
    conveynextConveyancerName: string | null;
    conveynextTotalPence: number | null;
    conveynextActionToken: string | null;
    proofOfFundsDocuments: Array<TProofOfFundsDocument2>;
    onLoadProofOfFundsDocuments: (enquiryId: string) => void;
    onUploadProofOfFundsDocument: (files: TProofOfFundsDocumentFileIO[]) => void;
    onDeleteProofOfFundsDocument: (form: TDeleteProofOfFundsDocumentFormIO) => void;
};

type TState = {
    isUpdatingOffer: boolean;
    isCompletionTimePopupOpen: boolean;
    isFallThroughRiskPopupOpen: boolean;
    isSolicitorSectionOpen: boolean;
    isSolicitorManualFormOpen: boolean;
    isMortgageBrokerSectionOpen: boolean;
    isProofOfFundsSectionOpen: boolean;
    isClientDetailsSectionOpen: boolean;
};

export class FrontYourOfferSummary extends React.Component<React.PropsWithChildren<TFrontYourOfferSummary>, TState> {

    constructor(props: TFrontYourOfferSummary) {
        super(props);
        this.state = {
            isUpdatingOffer: false,
            isCompletionTimePopupOpen: false,
            isFallThroughRiskPopupOpen: false,
            isSolicitorSectionOpen: false,
            isSolicitorManualFormOpen: false,
            isMortgageBrokerSectionOpen: false,
            isProofOfFundsSectionOpen: false,
            isClientDetailsSectionOpen: false,
        };
    }

    componentDidUpdate(prevProps: TFrontYourOfferSummary): void {
        // Auto-advance: on section save, open next incomplete section
        if (prevProps.clientDetailsForm.status !== "success" && this.props.clientDetailsForm.status === "success") {
            this.setState({ isClientDetailsSectionOpen: false });
            // Client details done → open proof of funds if not yet provided
            if (!this.props.thierLatestOffer.has_provided_proof_of_funds) {
                this.setState({ isProofOfFundsSectionOpen: true });
                this.prePopulateProofOfFundsForm();
            }
        }
        if (prevProps.proofOfFundsForm.status !== "success" && this.props.proofOfFundsForm.status === "success") {
            this.setState({ isProofOfFundsSectionOpen: false });
            // Proof of funds done → open solicitor if not yet provided
            if (!this.props.thierLatestOffer.has_provided_conveyancer_details) {
                this.setState({ isSolicitorSectionOpen: true });
                this.prePopulateConveyancerForm();
            }
        }
        if (prevProps.conveyancerForm.status !== "success" && this.props.conveyancerForm.status === "success") {
            this.setState({ isSolicitorSectionOpen: false, isSolicitorManualFormOpen: false });
            // Solicitor done → open mortgage broker if applicable and not yet provided
            if (this.props.thierLatestOffer.payment_method !== "cash" && !this.props.thierLatestOffer.has_provided_mortgage_broker_details) {
                this.setState({ isMortgageBrokerSectionOpen: true });
                this.prePopulateMortgageBrokerForm();
            }
        }
        if (prevProps.mortgageBrokerForm.status !== "success" && this.props.mortgageBrokerForm.status === "success") {
            this.setState({ isMortgageBrokerSectionOpen: false });
        }
    }

    closeAllSections = (): void => this.setState({
        isUpdatingOffer: false,
        isSolicitorSectionOpen: false,
        isSolicitorManualFormOpen: false,
        isMortgageBrokerSectionOpen: false,
        isProofOfFundsSectionOpen: false,
        isClientDetailsSectionOpen: false,
    });

    prePopulateConveyancerForm = (): void => {
        if (this.props.conveyancerForm.status !== "untouched") return;
        const offer = this.props.thierLatestOffer;
        this.props.onChangeConveyancerForm({
            ...this.props.conveyancerForm,
            edited: {
                ...this.props.conveyancerForm.edited,
                conveyancer_organisation_name: offer.conveyancer_organisation_name || "",
                conveyancer_name: offer.conveyancer_name || "",
                conveyancer_phone_number: offer.conveyancer_phone_number || "",
                conveyancer_email_address: offer.conveyancer_email_address || "",
                conveyancer_address: offer.conveyancer_address || "",
                conveyancer_confirmed_timeframe: offer.conveyancer_confirmed_timeframe,
            },
        });
    };

    prePopulateMortgageBrokerForm = (): void => {
        if (this.props.mortgageBrokerForm.status !== "untouched") return;
        const offer = this.props.thierLatestOffer;
        this.props.onChangeMortgageBrokerForm({
            ...this.props.mortgageBrokerForm,
            edited: {
                ...this.props.mortgageBrokerForm.edited,
                mortgage_broker_organisation_name: offer.mortgage_broker_organisation_name || "",
                mortgage_broker_name: offer.mortgage_broker_name || "",
                mortgage_broker_phone_number: offer.mortgage_broker_phone_number || "",
                mortgage_broker_email_address: offer.mortgage_broker_email_address || "",
            },
        });
    };

    prePopulateProofOfFundsForm = (): void => {
        if (this.props.proofOfFundsForm.status !== "untouched") return;
        const offer = this.props.thierLatestOffer;
        this.props.onChangeProofOfFundsForm({
            ...this.props.proofOfFundsForm,
            edited: {
                ...this.props.proofOfFundsForm.edited,
                funds_cash_verified_upto: offer.funds_cash_verified_upto || 0,
                funds_dip_verified_upto: offer.funds_dip_verified_upto || 0,
            },
        });
    };

    prePopulateClientDetailsForm = (): void => {
        if (this.props.clientDetailsForm.status !== "untouched") return;
        const offer = this.props.thierLatestOffer;
        this.props.onChangeClientDetailsForm({
            ...this.props.clientDetailsForm,
            edited: {
                ...this.props.clientDetailsForm.edited,
                homes_first_legal_name: offer.homes_first_legal_name || "",
                homes_middle_legal_name: offer.homes_middle_legal_name || "",
                homes_last_legal_name: offer.homes_last_legal_name || "",
                purchasers_address: offer.purchasers_address || "",
                purchasers_company_name: offer.purchasers_company_name || "",
            },
        });
    };

    toggleOfferUpdate = (): void => {
        this.closeAllSections();
        this.setState({ isUpdatingOffer: !this.state.isUpdatingOffer });
    };

    toggleCompletionTimePopup = (): void => this.setState({ isCompletionTimePopupOpen: !this.state.isCompletionTimePopupOpen });

    toggleFallThroughRiskPopup = (): void => this.setState({ isFallThroughRiskPopupOpen: !this.state.isFallThroughRiskPopupOpen });

    toggleSolicitorSection = (): void => {
        const opening = !this.state.isSolicitorSectionOpen;
        this.closeAllSections();
        this.setState({ isSolicitorSectionOpen: opening });
        if (opening) this.prePopulateConveyancerForm();
    };

    showManualForm = (): void => this.setState({ isSolicitorManualFormOpen: true });

    toggleMortgageBrokerSection = (): void => {
        const opening = !this.state.isMortgageBrokerSectionOpen;
        this.closeAllSections();
        this.setState({ isMortgageBrokerSectionOpen: opening });
        if (opening) {
            this.prePopulateMortgageBrokerForm();
            if (!this.props.thierLatestOffer.has_provided_mortgage_broker_details && this.props.mortgageBrokerForm.status === "success") {
                this.props.onChangeMortgageBrokerForm({ ...this.props.mortgageBrokerForm, status: "requiresSubmission" as const });
            }
        }
    };

    toggleProofOfFundsSection = (): void => {
        const opening = !this.state.isProofOfFundsSectionOpen;
        this.closeAllSections();
        this.setState({ isProofOfFundsSectionOpen: opening });
        if (opening) {
            this.prePopulateProofOfFundsForm();
            this.props.onLoadProofOfFundsDocuments(this.props.proofOfFundsForm.edited.enquiry_id);
        }
    };

    toggleClientDetailsSection = (): void => {
        const opening = !this.state.isClientDetailsSectionOpen;
        this.closeAllSections();
        this.setState({ isClientDetailsSectionOpen: opening });
        if (opening) this.prePopulateClientDetailsForm();
    };

    useRecommendedConveyancer = (): void => {
        const form = { ...this.props.conveyancerForm };
        form.edited = {
            ...form.edited,
            conveyancer_organisation_name: this.props.conveynextConveyancerName || "",
            conveyancer_name: "TBC",
            conveyancer_email_address: "salesmemos@conveynext.co.uk",
            conveyancer_phone_number: "02046002160",
            conveyancer_address: "TBC",
            conveyancer_confirmed_timeframe: true,
        };
        form.status = "requiresSubmission";
        this.props.onSubmitConveyancerForm(form);
    };

    hasClientDetailsBeenProvided = (): boolean => {
        const offer = this.props.thierLatestOffer;
        return !!(offer.homes_first_legal_name && offer.homes_last_legal_name && offer.purchasers_address);
    };

    timeToCompleteColour = (timeToComplete: TEstimatedTimeToCompletion1): TFrontMainColours => {
        switch (timeToComplete) {
            case "fast":
                return "highlights-positive-apple-10";
            case "medium":
                return "highlights-pertinent-coral-10";
            case "slow":
                return "highlights-error-firebrick-10";
            default:
                return requireExhaustive(timeToComplete);
        }
    };

    riskOfFallThroughDisplayColour = (risk: TRiskOfFallThrough1NewDfault): TFrontMainColours => {
        switch (risk) {
            case "high":
                return "highlights-error-firebrick-10";
            case "medium":
                return "highlights-pertinent-coral-10";
            case "low":
                return "highlights-positive-apple-10";
            default:
                return requireExhaustive(risk);
        }
    };

    renderBackButton = (onBack: () => void): JSX.Element => (
        <div>
            <span
                onClick={onBack}
                style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "4px" }}
            >
                <FrontParagraphTiny>
                    <FrontTextColour colour="neutral-11">
                        <WeightMedium>
                            &larr; Back
                        </WeightMedium>
                    </FrontTextColour>
                </FrontParagraphTiny>
            </span>
            <FrontSpacer size="small-2" />
        </div>
    );

    renderFormStatusMessages = (form: { status: string }): JSX.Element | null => (
        <>
            {form.status === "success" &&
                <>
                    <FrontRow justifyContent="start">
                        <FrontIcon iconName="tick" size="small" colour="highlights-positive-apple-10" />
                        <WeightMedium>
                            <FrontParagraphSmall>
                                <FrontTextColour colour="neutral-18">
                                    Saved
                                </FrontTextColour>
                            </FrontParagraphSmall>
                        </WeightMedium>
                    </FrontRow>
                    <FrontSpacer size="small-2" />
                </>
            }
            {form.status === "failure" &&
                <>
                    <WeightMedium>
                        <FrontParagraphSmall>
                            <FrontTextColour colour="highlights-error-firebrick-10">
                                Something went wrong. Please try again.
                            </FrontTextColour>
                        </FrontParagraphSmall>
                    </WeightMedium>
                    <FrontSpacer size="small-2" />
                </>
            }
            {form.status === "validationError" &&
                <>
                    <WeightMedium>
                        <FrontParagraphSmall>
                            <FrontTextColour colour="highlights-error-firebrick-10">
                                Please check all fields are filled in correctly.
                            </FrontTextColour>
                        </FrontParagraphSmall>
                    </WeightMedium>
                    <FrontSpacer size="small-2" />
                </>
            }
        </>
    );

    renderConveynextRecommendation = (): JSX.Element | null => {
        if (!this.props.conveynextConveyancerName || !this.props.conveynextTotalPence) {
            return null;
        }

        return (
            <div>
                <WeightMedium>
                    <FrontParagraphSmall>
                        <FrontTextColour colour="neutral-18">
                            Our recommended conveyancer
                        </FrontTextColour>
                    </FrontParagraphSmall>
                </WeightMedium>
                <FrontSpacer size="small-2" />

                <FrontParagraphTiny>
                    <FrontTextColour colour="neutral-18">
                        <WeightMedium>{this.props.conveynextConveyancerName}</WeightMedium>
                    </FrontTextColour>
                </FrontParagraphTiny>
                <FrontSpacer size="small-1" />

                <FrontParagraphTiny>
                    <FrontTextColour colour="neutral-18">
                        <WeightBold>
                            Total price: {TCurrency.fromNumber(this.props.conveynextTotalPence / 100, 2)}
                        </WeightBold>
                    </FrontTextColour>
                </FrontParagraphTiny>
                <FrontSpacer size="small-1" />

                <FrontParagraphTiny>
                    <FrontTextColour colour="highlights-positive-apple-10">
                        <WeightMedium>
                            This firm have accepted the agreed exchange deadline and can deliver in time
                        </WeightMedium>
                    </FrontTextColour>
                </FrontParagraphTiny>
                <FrontSpacer size="small-2" />

                {this.props.conveynextActionToken &&
                    <div>
                        <a
                            href={`${env.REACT_APP_API_URL}/v1/public/conveynext/${this.props.conveynextActionToken}/share`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#ffffff", textDecoration: "underline", fontSize: "13px" }}
                        >
                            Receive the quote by email
                        </a>
                        <FrontSpacer size="small-2" />
                    </div>
                }

                <div className="front-your-offer-summary__conveyancer-buttons">
                    <FrontButtonPrimary
                        label="Use our recommended conveyancer"
                        fullWidth={true}
                        onClick={this.useRecommendedConveyancer}
                    />
                    <FrontFormSecondaryButton
                        label="Use my own conveyancer"
                        onClick={this.showManualForm}
                    />
                </div>
                <FrontSpacer size="medium-1" />
            </div>
        );
    };

    formatNumberWithCommas = (value: number): string =>
        value > 0 ? value.toLocaleString("en-GB") : "";

    parseFormattedNumber = (value: string): number => {
        const stripped = value.replace(/,/g, "");
        return Math.max(0, parseFloat(stripped) || 0);
    };

    isValidEmail = (email: string): boolean => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email);

    isValidPhone = (phone: string): boolean => /^(\+[1-9]|0)[\d\s]+$/.test(phone.trim()) && phone.replace(/\s/g, "").length >= 7;

    validateAndSubmitConveyancerForm = (): void => {
        const form = this.props.conveyancerForm;
        const phone = form.edited.conveyancer_phone_number.trim();
        const email = form.edited.conveyancer_email_address.trim();
        const hasErrors = !form.edited.conveyancer_organisation_name.trim()
            || !form.edited.conveyancer_name.trim()
            || !phone || !this.isValidPhone(phone)
            || !email || !this.isValidEmail(email)
            || !form.edited.conveyancer_address.trim();
        if (hasErrors) {
            this.props.onChangeConveyancerForm({ ...form, status: "validationError" as const });
            return;
        }
        this.props.onSubmitConveyancerForm(form);
    };

    validateAndSubmitMortgageBrokerForm = (): void => {
        const form = this.props.mortgageBrokerForm;
        const phone = form.edited.mortgage_broker_phone_number.trim();
        const email = form.edited.mortgage_broker_email_address.trim();
        const hasErrors = !form.edited.mortgage_broker_organisation_name.trim()
            || !form.edited.mortgage_broker_name.trim()
            || !phone || !this.isValidPhone(phone)
            || !email || !this.isValidEmail(email);
        if (hasErrors) {
            this.props.onChangeMortgageBrokerForm({ ...form, status: "validationError" as const });
            return;
        }
        this.props.onSubmitMortgageBrokerForm(form);
    };

    renderConveyancerManualForm = (): JSX.Element => {
        const form = this.props.conveyancerForm;
        const showValidation = form.status === "validationError";
        const emailValue = form.edited.conveyancer_email_address.trim();
        const phoneValue = form.edited.conveyancer_phone_number.trim();

        return (
            <div>
                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Organisation name" displayError={showValidation && !form.edited.conveyancer_organisation_name.trim()} errorMessage="Organisation name is required">
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={showValidation && !form.edited.conveyancer_organisation_name.trim()}
                        value={form.edited.conveyancer_organisation_name}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, conveyancer_organisation_name: val }, status: "requiresSubmission" as const };
                            this.props.onChangeConveyancerForm(updated);
                        }}
                        maxLength={500}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Conveyancer name" displayError={showValidation && !form.edited.conveyancer_name.trim()} errorMessage="Conveyancer name is required">
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={showValidation && !form.edited.conveyancer_name.trim()}
                        value={form.edited.conveyancer_name}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, conveyancer_name: val }, status: "requiresSubmission" as const };
                            this.props.onChangeConveyancerForm(updated);
                        }}
                        maxLength={500}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Phone number" displayError={showValidation && (!phoneValue || !this.isValidPhone(phoneValue))} errorMessage={!phoneValue ? "Phone number is required" : "Enter a valid phone number (e.g. 02012345678)"}>
                    <FrontInputGeneralComponent
                        inputType="tel"
                        displayError={showValidation && (!phoneValue || !this.isValidPhone(phoneValue))}
                        value={form.edited.conveyancer_phone_number}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, conveyancer_phone_number: val }, status: "requiresSubmission" as const };
                            this.props.onChangeConveyancerForm(updated);
                        }}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Email address" displayError={showValidation && (!emailValue || !this.isValidEmail(emailValue))} errorMessage={!emailValue ? "Email address is required" : "Enter a valid email address"}>
                    <FrontInputGeneralComponent
                        inputType="email"
                        displayError={showValidation && (!emailValue || !this.isValidEmail(emailValue))}
                        value={form.edited.conveyancer_email_address}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, conveyancer_email_address: val }, status: "requiresSubmission" as const };
                            this.props.onChangeConveyancerForm(updated);
                        }}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Address" displayError={showValidation && !form.edited.conveyancer_address.trim()} errorMessage="Address is required">
                    <FrontInputTextareaComponent
                        value={form.edited.conveyancer_address}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, conveyancer_address: val }, status: "requiresSubmission" as const };
                            this.props.onChangeConveyancerForm(updated);
                        }}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="medium-1" />

                {form.status !== "success" &&
                    <FrontRow justifyContent="end">
                        <FrontButtonPrimary
                            label="Save"
                            onClick={this.validateAndSubmitConveyancerForm}
                        />
                    </FrontRow>
                }
            </div>
        );
    };

    renderSolicitorSection = (): JSX.Element => {
        const form = this.props.conveyancerForm;
        const hasConveynextQuote = !!this.props.conveynextConveyancerName && !!this.props.conveynextTotalPence;

        return (
            <div>
                {this.renderBackButton(() => this.setState({ isSolicitorSectionOpen: false }))}

                <WeightMedium>
                    <FrontParagraphSmall>
                        <FrontTextColour colour="neutral-18">
                            Solicitor's Details
                        </FrontTextColour>
                    </FrontParagraphSmall>
                </WeightMedium>
                <FrontSpacer size="medium-1" />

                {this.renderFormStatusMessages(form)}

                {form.status !== "success" && hasConveynextQuote && !this.state.isSolicitorManualFormOpen &&
                    this.renderConveynextRecommendation()
                }

                {form.status !== "success" && (!hasConveynextQuote || this.state.isSolicitorManualFormOpen) &&
                    this.renderConveyancerManualForm()
                }
            </div>
        );
    };

    renderMortgageBrokerManualForm = (): JSX.Element => {
        const form = this.props.mortgageBrokerForm;
        const showValidation = form.status === "validationError";
        const emailValue = form.edited.mortgage_broker_email_address.trim();
        const phoneValue = form.edited.mortgage_broker_phone_number.trim();

        return (
            <div>
                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Organisation name" displayError={showValidation && !form.edited.mortgage_broker_organisation_name.trim()} errorMessage="Organisation name is required">
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={showValidation && !form.edited.mortgage_broker_organisation_name.trim()}
                        value={form.edited.mortgage_broker_organisation_name}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, mortgage_broker_organisation_name: val }, status: "requiresSubmission" as const };
                            this.props.onChangeMortgageBrokerForm(updated);
                        }}
                        maxLength={500}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Broker name" displayError={showValidation && !form.edited.mortgage_broker_name.trim()} errorMessage="Broker name is required">
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={showValidation && !form.edited.mortgage_broker_name.trim()}
                        value={form.edited.mortgage_broker_name}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, mortgage_broker_name: val }, status: "requiresSubmission" as const };
                            this.props.onChangeMortgageBrokerForm(updated);
                        }}
                        maxLength={500}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Phone number" displayError={showValidation && (!phoneValue || !this.isValidPhone(phoneValue))} errorMessage={!phoneValue ? "Phone number is required" : "Enter a valid phone number (e.g. 02012345678)"}>
                    <FrontInputGeneralComponent
                        inputType="tel"
                        displayError={showValidation && (!phoneValue || !this.isValidPhone(phoneValue))}
                        value={form.edited.mortgage_broker_phone_number}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, mortgage_broker_phone_number: val }, status: "requiresSubmission" as const };
                            this.props.onChangeMortgageBrokerForm(updated);
                        }}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Email address" displayError={showValidation && (!emailValue || !this.isValidEmail(emailValue))} errorMessage={!emailValue ? "Email address is required" : "Enter a valid email address"}>
                    <FrontInputGeneralComponent
                        inputType="email"
                        displayError={showValidation && (!emailValue || !this.isValidEmail(emailValue))}
                        value={form.edited.mortgage_broker_email_address}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, mortgage_broker_email_address: val }, status: "requiresSubmission" as const };
                            this.props.onChangeMortgageBrokerForm(updated);
                        }}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="medium-1" />

                {form.status !== "success" &&
                    <FrontRow justifyContent="end">
                        <FrontButtonPrimary
                            label="Save"
                            onClick={this.validateAndSubmitMortgageBrokerForm}
                        />
                    </FrontRow>
                }
            </div>
        );
    };

    renderMortgageBrokerSection = (): JSX.Element => {
        const form = this.props.mortgageBrokerForm;

        return (
            <div>
                {this.renderBackButton(() => this.setState({ isMortgageBrokerSectionOpen: false }))}

                <WeightMedium>
                    <FrontParagraphSmall>
                        <FrontTextColour colour="neutral-18">
                            Mortgage Broker's Details
                        </FrontTextColour>
                    </FrontParagraphSmall>
                </WeightMedium>
                <FrontSpacer size="medium-1" />

                {this.renderFormStatusMessages(form)}

                {form.status !== "success" &&
                    this.renderMortgageBrokerManualForm()
                }
            </div>
        );
    };

    renderProofOfFundsForm = (): JSX.Element => {
        const form = this.props.proofOfFundsForm;
        const showValidation = form.status === "validationError";
        const cashPounds = form.edited.funds_cash_verified_upto / 100;
        const dipPounds = form.edited.funds_dip_verified_upto / 100;
        const offerAmountPence = this.props.thierLatestOffer.amount * 100;
        const ltvDisplay = offerAmountPence > 0 && form.edited.funds_dip_verified_upto > 0
            ? Math.round((form.edited.funds_dip_verified_upto / offerAmountPence) * 100)
            : 0;
        const neitherProvided = form.edited.funds_cash_verified_upto <= 0 && form.edited.funds_dip_verified_upto <= 0;

        return (
            <div>
                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Cash funds available" displayError={showValidation && neitherProvided} errorMessage="At least one of cash funds or mortgage amount must be greater than zero">
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={showValidation && neitherProvided}
                        value={this.formatNumberWithCommas(cashPounds)}
                        onChange={(val) => {
                            const pence = Math.round(this.parseFormattedNumber(val) * 100);
                            const updated = { ...form, edited: { ...form.edited, funds_cash_verified_upto: pence }, status: "requiresSubmission" as const };
                            this.props.onChangeProofOfFundsForm(updated);
                        }}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Mortgage amount (DIP)" displayError={showValidation && neitherProvided} errorMessage="At least one of cash funds or mortgage amount must be greater than zero">
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={showValidation && neitherProvided}
                        value={this.formatNumberWithCommas(dipPounds)}
                        onChange={(val) => {
                            const pence = Math.round(this.parseFormattedNumber(val) * 100);
                            const updated = { ...form, edited: { ...form.edited, funds_dip_verified_upto: pence }, status: "requiresSubmission" as const };
                            this.props.onChangeProofOfFundsForm(updated);
                        }}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                {ltvDisplay > 0 &&
                    <FrontParagraphTiny>
                        <FrontTextColour colour="neutral-18">
                            <WeightMedium>
                                Loan to value: {ltvDisplay}%
                            </WeightMedium>
                        </FrontTextColour>
                    </FrontParagraphTiny>
                }
                <FrontSpacer size="medium-1" />

                {form.status !== "success" &&
                    <FrontRow justifyContent="end">
                        <FrontButtonPrimary
                            label="Save"
                            onClick={() => this.props.onSubmitProofOfFundsForm(form)}
                        />
                    </FrontRow>
                }
            </div>
        );
    };

    handleProofOfFundsFileChange = (files: FileList | null): void => {
        if (!files || files.length === 0) return;
        const maxSize = 15 * 1024 * 1024;
        const fileArray = Array.from(files);
        const validFiles = pipe(
            fileArray,
            array.filterMap<File, TProofOfFundsDocumentFileIO>((file) => {
                if (file.size > maxSize) {
                    return option.none;
                }
                const indexOfLastFullStopInFileName = file.name.lastIndexOf(".");
                return option.some<TProofOfFundsDocumentFileIO>({
                    ...ProofOfFundsDocumentFileIO.newDefault(),
                    status: "requiresSubmission",
                    input: {
                        request_ref: uuidv4(),
                        listings_enquiry_id: this.props.proofOfFundsForm.edited.enquiry_id,
                        name: indexOfLastFullStopInFileName >= 0 ? file.name.slice(0, indexOfLastFullStopInFileName) : file.name,
                        file_extension: indexOfLastFullStopInFileName >= 0 ? file.name.slice(indexOfLastFullStopInFileName + 1) : "",
                        mime_type: file.type === "" ? "application/octet-stream" : file.type,
                    },
                    clientSideFileForUpload: file,
                });
            }),
        );
        if (validFiles.length < fileArray.length) {
            alert("Some files were too large (max 15MB) and were not uploaded.");
        }
        if (validFiles.length > 0) {
            this.props.onUploadProofOfFundsDocument(validFiles);
        }
    };

    renderProofOfFundsDocuments = (): JSX.Element => {
        const documents = this.props.proofOfFundsDocuments;

        return (
            <div>
                <FrontSpacer size="medium-1" />
                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Upload evidence of funds" displayError={false}>
                    <div style={{ marginBottom: "8px" }}>
                        <span style={{ fontSize: "12px", color: "#8b97a7" }}>
                            Bank statements, mortgage agreements or DIP documents (PDF or images, max 15MB).
                        </span>
                    </div>
                    <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png,.gif,.webp"
                        multiple
                        onChange={(e) => this.handleProofOfFundsFileChange(e.currentTarget.files)}
                        style={{ display: "none" }}
                        ref={(ref) => { this.proofOfFundsFileInputRef = ref; }}
                    />
                    <FrontButtonMicro
                        label="Choose files"
                        colour="primary-6"
                        onClick={() => this.proofOfFundsFileInputRef?.click()}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                {documents.length > 0 &&
                    <div style={{ marginTop: "8px" }}>
                        {documents.map((doc) =>
                            <div key={doc.id} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                                <a href={doc.url} target="_blank" rel="noopener noreferrer" style={{ color: "#51b8c4", fontSize: "13px", textDecoration: "underline" }}>
                                    {doc.name}.{doc.file_extension}
                                </a>
                                <span
                                    onClick={() => {
                                        const deleteForm: TDeleteProofOfFundsDocumentFormIO = {
                                            ...DeleteProofOfFundsDocumentFormIO.newDefault(),
                                            input: { id: doc.delete_form.input.id },
                                        };
                                        this.props.onDeleteProofOfFundsDocument(deleteForm);
                                    }}
                                    style={{ color: "#8b97a7", fontSize: "12px", cursor: "pointer", textDecoration: "underline" }}
                                >
                                    Remove
                                </span>
                            </div>
                        )}
                    </div>
                }
            </div>
        );
    };

    proofOfFundsFileInputRef: HTMLInputElement | null = null;

    renderProofOfFundsSection = (): JSX.Element => {
        const form = this.props.proofOfFundsForm;

        return (
            <div>
                {this.renderBackButton(() => this.setState({ isProofOfFundsSectionOpen: false }))}

                <WeightMedium>
                    <FrontParagraphSmall>
                        <FrontTextColour colour="neutral-18">
                            Proof of Funds
                        </FrontTextColour>
                    </FrontParagraphSmall>
                </WeightMedium>
                <FrontSpacer size="medium-1" />

                {this.renderFormStatusMessages(form)}

                {form.status !== "success" &&
                    this.renderProofOfFundsForm()
                }

                {this.renderProofOfFundsDocuments()}
            </div>
        );
    };

    renderClientDetailsForm = (): JSX.Element => {
        const form = this.props.clientDetailsForm;
        const showValidation = form.status === "validationError";

        return (
            <div>
                <FrontInputLabelAndErrorWrapComponent theme="dark" label="First name" displayError={showValidation && !form.edited.homes_first_legal_name.trim()} errorMessage="First name is required">
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={showValidation && !form.edited.homes_first_legal_name.trim()}
                        value={form.edited.homes_first_legal_name}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, homes_first_legal_name: val }, status: "requiresSubmission" as const };
                            this.props.onChangeClientDetailsForm(updated);
                        }}
                        maxLength={200}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Middle name(s)" displayError={false}>
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={false}
                        value={form.edited.homes_middle_legal_name}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, homes_middle_legal_name: val }, status: "requiresSubmission" as const };
                            this.props.onChangeClientDetailsForm(updated);
                        }}
                        maxLength={200}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Last name" displayError={showValidation && !form.edited.homes_last_legal_name.trim()} errorMessage="Last name is required">
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={showValidation && !form.edited.homes_last_legal_name.trim()}
                        value={form.edited.homes_last_legal_name}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, homes_last_legal_name: val }, status: "requiresSubmission" as const };
                            this.props.onChangeClientDetailsForm(updated);
                        }}
                        maxLength={200}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Address" displayError={showValidation && !form.edited.purchasers_address.trim()} errorMessage="Address is required">
                    <FrontInputTextareaComponent
                        value={form.edited.purchasers_address}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, purchasers_address: val }, status: "requiresSubmission" as const };
                            this.props.onChangeClientDetailsForm(updated);
                        }}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="small-2" />

                <FrontInputLabelAndErrorWrapComponent theme="dark" label="Company name (if applicable)" displayError={false}>
                    <FrontInputGeneralComponent
                        inputType="text"
                        displayError={false}
                        value={form.edited.purchasers_company_name}
                        onChange={(val) => {
                            const updated = { ...form, edited: { ...form.edited, purchasers_company_name: val }, status: "requiresSubmission" as const };
                            this.props.onChangeClientDetailsForm(updated);
                        }}
                        maxLength={500}
                    />
                </FrontInputLabelAndErrorWrapComponent>
                <FrontSpacer size="medium-1" />

                {form.status !== "success" &&
                    <FrontRow justifyContent="end">
                        <FrontButtonPrimary
                            label="Save"
                            onClick={() => this.props.onSubmitClientDetailsForm(form)}
                        />
                    </FrontRow>
                }
            </div>
        );
    };

    renderClientDetailsSection = (): JSX.Element => {
        const form = this.props.clientDetailsForm;

        return (
            <div>
                {this.renderBackButton(() => this.setState({ isClientDetailsSectionOpen: false }))}

                <WeightMedium>
                    <FrontParagraphSmall>
                        <FrontTextColour colour="neutral-18">
                            Client Details
                        </FrontTextColour>
                    </FrontParagraphSmall>
                </WeightMedium>
                <FrontSpacer size="medium-1" />

                {this.renderFormStatusMessages(form)}

                {form.status !== "success" &&
                    this.renderClientDetailsForm()
                }
            </div>
        );
    };

    renderChecklistIndicators = (): JSX.Element => {
        const offer = this.props.thierLatestOffer;

        return (
            <div className="front-your-offer-summary__checklist-indicators">
                {this.props.thierLatestOffer.payment_method !== "cash" &&
                    <FrontRow justifyContent="start">
                        <FrontIcon
                            iconName={offer.mortgage_broker_has_vouched ? "tick" : "cross"}
                            size="small"
                            colour={offer.mortgage_broker_has_vouched ? "highlights-positive-apple-10" : "neutral-11"}
                        />
                        <FrontParagraphTiny>
                            <FrontTextColour colour="neutral-18">
                                <WeightMedium>
                                    Broker has vouched for buyer
                                </WeightMedium>
                            </FrontTextColour>
                        </FrontParagraphTiny>
                    </FrontRow>
                }
                <FrontRow justifyContent="start">
                    <FrontIcon
                        iconName={offer.conveyancer_confirmed_timeframe ? "tick" : "cross"}
                        size="small"
                        colour={offer.conveyancer_confirmed_timeframe ? "highlights-positive-apple-10" : "neutral-11"}
                    />
                    <FrontParagraphTiny>
                        <FrontTextColour colour="neutral-18">
                            <WeightMedium>
                                Solicitor confirmed timeframe
                            </WeightMedium>
                        </FrontTextColour>
                    </FrontParagraphTiny>
                </FrontRow>
            </div>
        );
    };

    public render (): JSX.Element {
        return (
            <>
                <div className="front-your-offer-summary">
                    {/* HEADER */}
                    <div className="front-your-offer-summary__header">
                        <WeightMedium>
                            <FrontTitleMinor>
                                <FrontTextColour colour="neutral-18">
                                    Your Offer
                                </FrontTextColour>
                            </FrontTitleMinor>
                        </WeightMedium>

                        <FrontButtonMicro
                            label={this.state.isUpdatingOffer ? "Close" : "Change Offer"}
                            onClick={this.toggleOfferUpdate}
                        />
                    </div>
                    <FrontSpacer size="medium-2" />

                    {/* AMOUNT */}
                    <div className="front-your-offer-summary__amount">
                        <WeightBold>
                            <FrontTitlePageSection>
                                <FrontTextColour colour="neutral-18">
                                    {TCurrency.fromNumber(this.props.thierLatestOffer.amount)}
                                </FrontTextColour>
                            </FrontTitlePageSection>
                        </WeightBold>
                    </div>
                    <FrontSpacer size="medium-1" />

                    {/* BODY */}
                    <div className="front-your-offer-summary__body">
                        {/* BODY: OFFER SUMMARY */}
                        <div className={`
                            front-your-offer-summary__summary-body

                        `}>
                            <div className="front-your-offer-summary__gauges">
                                <FrontOfferSummaryGauge
                                    label="Your current completion time"
                                    colour={this.timeToCompleteColour(this.props.thierLatestOffer.estimated_time_to_complete)}
                                    title={this.props.thierLatestOffer.estimated_time_to_complete}
                                    onClickInfo={this.toggleCompletionTimePopup}
                                />
                                <div className="front-your-offer-summary__seperator"></div>
                                <FrontOfferSummaryGauge
                                    label="Your current risk of fall through"
                                    colour={this.riskOfFallThroughDisplayColour(this.props.thierLatestOffer.risk_of_fall_through)}
                                    title={this.props.thierLatestOffer.risk_of_fall_through}
                                    onClickInfo={this.toggleFallThroughRiskPopup}
                                />
                            </div>
                            <FrontSpacer size="medium-2" />

                            {/* PARAGRAPH */}
                            <FrontParagraphTiny>
                                <FrontTextColour colour="neutral-11">
                                    <WeightMedium>
                                        The seller assesses your offer based on its
                                        &nbsp;
                                        <Underline>
                                            completion time
                                        </Underline>
                                        &nbsp;
                                        and
                                        &nbsp;
                                        <Underline>
                                            fall through risk.
                                        </Underline>
                                    </WeightMedium>
                                    <WeightBold>
                                        &nbsp;You can improve these by providing the information below.
                                    </WeightBold>
                                </FrontTextColour>
                            </FrontParagraphTiny>
                            <FrontSpacer size="large-1" />

                            {/* STEPS COMPLETED */}
                            <div className="front-your-offer-summary__completion-icons">
                                {/* YOUR OFFER */}
                                <FrontOfferSummaryStatusIcon
                                    isComplete={true}
                                    icon="money"
                                    title="offer"
                                    isClickable={false}
                                    onClick={() => undefined}
                                />
                                <FrontSpacer size="medium-2" />
                                {/* CLIENT DETAILS */}
                                <FrontOfferSummaryStatusIcon
                                    isComplete={this.hasClientDetailsBeenProvided()}
                                    icon="id-card"
                                    title="client details"
                                    isClickable={true}
                                    onClick={this.toggleClientDetailsSection}
                                />
                                <FrontSpacer size="medium-2" />
                                {/* PROOF OF FUNDS */}
                                <FrontOfferSummaryStatusIcon
                                    isComplete={this.props.thierLatestOffer.has_provided_proof_of_funds}
                                    icon="coins"
                                    title="pof"
                                    isClickable={true}
                                    onClick={this.toggleProofOfFundsSection}
                                />
                                <FrontSpacer size="medium-2" />
                                {/* SOLICITOR DETAILS */}
                                <FrontOfferSummaryStatusIcon
                                    isComplete={this.props.thierLatestOffer.has_provided_conveyancer_details}
                                    icon="contract"
                                    title="solicitor"
                                    isClickable={true}
                                    onClick={this.toggleSolicitorSection}
                                />
                                <FrontSpacer size="medium-2" />
                                {/* MORTGAGE BROKER DETAILS */}
                                {this.props.thierLatestOffer.payment_method !== "cash" && <FrontOfferSummaryStatusIcon
                                    isComplete={this.props.thierLatestOffer.has_provided_mortgage_broker_details}
                                    icon="bank"
                                    title="broker"
                                    isClickable={true}
                                    onClick={this.toggleMortgageBrokerSection}
                                />}
                            </div>
                            <FrontSpacer size="medium-1" />

                            {/* CHECKLIST INDICATORS */}
                            {this.renderChecklistIndicators()}
                        </div>

                        {/* BODY: CHANGE OFFER */}
                        <div
                            className={`
                                front-your-offer-summary__change-offer-body
                                front-your-offer-summary__change-offer-body--${this.state.isUpdatingOffer ? "visible" : "hidden"}
                            `}
                        >
                            <div className="front-your-offer-summary__change-offer-body-paragraph">
                                {this.props.newOfferForm.status !== "success" &&
                                    <>
                                        {this.renderBackButton(this.toggleOfferUpdate)}
                                        <FrontParagraphSmall>
                                            <WeightMedium>
                                                <FrontTextColour colour="neutral-18">
                                                    You can make as many changes to your offer as you like by entering a new offer in here. We'll then pass the update straight onto the seller.
                                                </FrontTextColour>
                                            </WeightMedium>
                                        </FrontParagraphSmall>
                                        <FrontSpacer size="medium-2" />
                                    </>
                                }
                                <FrontInputCurrencyHuge
                                    formStatus={this.props.newOfferForm.status}
                                    value={this.props.newOfferForm.edited.amount}
                                    onChange={(val) => {
                                        this.props.newOfferForm.edited.amount = val || 0;
                                        this.props.newOfferForm.status = "untouched";
                                        this.props.onChangeNewOfferForm(this.props.newOfferForm);
                                    }}
                                    onPressEnterKey={() => null}
                                />
                                <FrontSpacer size="medium-2" />

                                {/* IF NOT SUCCESS: SUBMIT BUTTON */}
                                {this.props.newOfferForm.status !== "success" &&
                                    <>
                                        <FrontRow justifyContent="end">
                                            <FrontButtonPrimary
                                                label="Submit"
                                                onClick={() => this.props.onSubmitNewOfferForm(this.props.newOfferForm)}
                                            />
                                        </FrontRow>
                                        <FrontSpacer size="medium-1" />
                                    </>
                                }

                                {this.props.newOfferForm.status === "success" &&
                                    <>
                                        <FrontRow justifyContent="start">
                                            <FrontIcon iconName="tick" size="small" colour="highlights-positive-apple-10" />
                                            <WeightMedium>
                                                <FrontParagraphSmall>
                                                    <FrontTextColour colour="neutral-18">
                                                        Offer Updated
                                                    </FrontTextColour>
                                                </FrontParagraphSmall>
                                            </WeightMedium>
                                        </FrontRow>
                                        <FrontSpacer size="small-2" />

                                        <WeightMedium>
                                            <FrontParagraphSmall>
                                                <FrontTextColour colour="neutral-18">
                                                    We've got your new offer and we'll share that with the seller.
                                                </FrontTextColour>
                                            </FrontParagraphSmall>
                                        </WeightMedium>
                                    </>
                                }

                                {this.props.newOfferForm.status === "validationError" &&
                                    <WeightMedium>
                                        <FrontParagraphSmall>
                                            <FrontTextColour colour="neutral-18">
                                                You need to enter an amount before submitting your new offer.
                                            </FrontTextColour>
                                        </FrontParagraphSmall>
                                    </WeightMedium>
                                }

                                {this.props.newOfferForm.status === "failure" &&
                                    <>
                                        <WeightMedium>
                                            <FrontParagraphSmall>
                                                <FrontTextColour colour="neutral-18">
                                                    Your offer could not be updated
                                                </FrontTextColour>
                                            </FrontParagraphSmall>
                                        </WeightMedium>
                                        <FrontSpacer size="small-2" />

                                        <WeightMedium>
                                            <FrontParagraphSmall>
                                                <FrontTextColour colour="neutral-18">
                                                    You can try again, if the issue presists do not hesitate to contact us.
                                                </FrontTextColour>
                                            </FrontParagraphSmall>
                                        </WeightMedium>
                                    </>
                                }
                            </div>
                        </div>

                        {/* BODY: CLIENT DETAILS */}
                        <div
                            className={`
                                front-your-offer-summary__change-offer-body
                                front-your-offer-summary__change-offer-body--${this.state.isClientDetailsSectionOpen ? "visible" : "hidden"}
                            `}
                        >
                            <div className="front-your-offer-summary__change-offer-body-paragraph">
                                {this.renderClientDetailsSection()}
                            </div>
                        </div>

                        {/* BODY: PROOF OF FUNDS */}
                        <div
                            className={`
                                front-your-offer-summary__change-offer-body
                                front-your-offer-summary__change-offer-body--${this.state.isProofOfFundsSectionOpen ? "visible" : "hidden"}
                            `}
                        >
                            <div className="front-your-offer-summary__change-offer-body-paragraph">
                                {this.renderProofOfFundsSection()}
                            </div>
                        </div>

                        {/* BODY: SOLICITOR DETAILS */}
                        <div
                            className={`
                                front-your-offer-summary__change-offer-body
                                front-your-offer-summary__change-offer-body--${this.state.isSolicitorSectionOpen ? "visible" : "hidden"}
                            `}
                        >
                            <div className="front-your-offer-summary__change-offer-body-paragraph">
                                {this.renderSolicitorSection()}
                            </div>
                        </div>

                        {/* BODY: MORTGAGE BROKER DETAILS */}
                        <div
                            className={`
                                front-your-offer-summary__change-offer-body
                                front-your-offer-summary__change-offer-body--${this.state.isMortgageBrokerSectionOpen ? "visible" : "hidden"}
                            `}
                        >
                            <div className="front-your-offer-summary__change-offer-body-paragraph">
                                {this.renderMortgageBrokerSection()}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Popups */}
                <FrontCompletionTimeModal
                    isOpen={this.state.isCompletionTimePopupOpen}
                    onClose={this.toggleCompletionTimePopup}
                    thierLatestOffer={this.props.thierLatestOffer}
                />

                <FrontFallThroughRiskModal
                    isOpen={this.state.isFallThroughRiskPopupOpen}
                    onClose={this.toggleFallThroughRiskPopup}
                    thierLatestOffer={this.props.thierLatestOffer}
                />
            </>
        );
    }
}
